import { rootApi } from "../../api/rootApi";

export const feedBackProductApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductFeedback: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/productFeedback`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),


    countProductFeedback: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/productFeedback/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

  }),
});

export const {
  useFetchProductFeedbackMutation,
  useCountProductFeedbackMutation
} = feedBackProductApi;
